import { useBoolean } from '@rothzerg/useboolean'
import React, { useState } from 'react'
import { createUseStyles } from 'react-jss'
import { isEmail, isEmpty } from '@rothzerg/validator'
import axios from 'axios'

import FormInput from '../ui/Form/FormInput'
import Gtm from '../../utils/gtm'
import { loggingEnabled } from '../../utils/logging'

const useStyles = createUseStyles(theme => ({
  container: {
    margin: '0 auto',
    width: '100%',
    maxWidth: '590px',
    '@media (max-width: 600px)': {
      boxSizing: 'border-box',
      padding: '0 15px',
    },
  },
  desc: {
    fontSize: 16,
    lineHeight: 1.5,
    letterSpacing: '0.02em',
    color: '#000',
    marginBottom: '50px',
    fontWeight: 'normal',
  },
  flexCont: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 20,
    '@media (max-width: 600px)': {
      gridTemplateColumns: '1fr',
      gap: 0,
    },
  },
  buttonPrimary: {
    display: 'inline-block',
    padding: '18px 30px 16px',
    color: '#fff',
    backgroundColor: theme.colors.orange,
    border: `2px solid ${theme.colors.orange}`,
    borderRadius: '18px',
    lineHeight: '18px',
    fontSize: '18px',
    fontWeight: 700,
    textDecoration: 'none',
    transition: 'all 250ms cubic-bezier(.215,.61,.355,1)',
    '&:hover': {
      backgroundColor: theme.colors.orangeHover,
      border: `2px solid ${theme.colors.orangeHover}`,
      cursor: 'pointer',
    },
  },
}))

const Signup = props => {
  const classes = useStyles()
  const gtm = new Gtm(loggingEnabled)
  const [formSubmitting, setFormSubmitting] = useBoolean()
  const [email, setEmail] = useState('')
  const [fname, setFname] = useState('')
  const [lname, setLname] = useState('')

  const [emailError, setEmailError] = useState(undefined)
  const [fnameError, setFnameError] = useState(undefined)
  const [lnameError, setLnameError] = useState(undefined)
  const [formStatus, setFormStatus] = useState(null)

  if (!props.desc) return null

  const { desc, brand, culture, seg, sourceCode, sourceSystem } = props

  const submitForm = () => {
    let error = false
    setEmailError(undefined)
    setFnameError(undefined)
    setLnameError(undefined)

    if (!isEmail(email)) {
      setEmailError(['Please enter a valid email address'])
      gtm.formErrorDisplay('signup', 'Please enter a valid email address')
      error = true
    }
    if (isEmpty(fname)) {
      setFnameError(['Please enter your first name'])
      gtm.formErrorDisplay('signup', 'Please enter your first name')
      error = true
    }
    if (isEmpty(lname)) {
      setLnameError(['Please enter your last name'])
      gtm.formErrorDisplay('signup', 'Please enter your last name')
      error = true
    }

    if (!error) {
      setFormSubmitting.true()
      const params = new URLSearchParams()
      params.append('email', email)
      params.append('firstName', fname)
      params.append('lastName', lname)
      params.append('countryDetails', false)
      params.append('countryRelocation', false)
      params.append('brand', brand)
      params.append('culture', culture)
      params.append('seg', seg)
      params.append('sourceCode', sourceCode)
      params.append('sourceSystem', sourceSystem)

      axios
        .post('/api/signup', params)
        .then(({ data }) => {
          setFormSubmitting.false()
          setFormStatus(data.status)
        })
        .catch(err => {
          console.error(err)
        })
    }
  }

  return (
    <div className={classes.container}>
      <p className={classes.desc}>{desc}</p>

      <div>
        {formStatus === false && (
          <div
            style={{
              borderRadius: '5px',
              backgroundColor: '#fff',
              color: '#c72724',
              padding: '12px',
              marginTop: '25px',
              fontSize: '16px',
              fontWeight: 500,
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <img
              src="/themes/thrifty/assets/images/error.png"
              width={20}
              style={{ marginRight: '7px' }}
            />
            <span>There was a problem submitting the form, please try again later</span>
          </div>
        )}
        {formStatus === true && (
          <div
            style={{
              borderRadius: '5px',
              backgroundColor: '#fff',
              color: '#000',
              padding: '12px',
              marginTop: '25px',
              fontSize: '16px',
              fontWeight: 500,
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <img
              src="/themes/thrifty/assets/images/success.png"
              width={20}
              style={{ marginRight: '7px' }}
            />
            <span>Thank you for signing up to our mailing list!</span>
          </div>
        )}
      </div>
      <div className={classes.flexCont}>
        <div>
          <FormInput
            disabled={formSubmitting}
            greyBackground={false}
            error={fnameError}
            labelText="First Name*"
            inputType="text"
            defaultValue=""
            onChange={el => {
              setFname(el.currentTarget.value)
            }}
          />
        </div>
        <div>
          <FormInput
            disabled={formSubmitting}
            greyBackground={false}
            labelText="Last Name*"
            inputType="text"
            defaultValue=""
            error={lnameError}
            onChange={el => {
              setLname(el.currentTarget.value)
            }}
          />
        </div>
      </div>
      <div className={classes.flexContFull}>
        <div>
          <FormInput
            disabled={formSubmitting}
            greyBackground={false}
            labelText="Email Address*"
            inputType="email"
            defaultValue=""
            error={emailError}
            onChange={el => {
              setEmail(el.currentTarget.value)
            }}
          />
        </div>
      </div>

      <div style={{ textAlign: 'center', paddingTop: 35, paddingBottom: 35 }}>
        <button onClick={submitForm} className={classes.buttonPrimary}>
          Sign Up
        </button>
      </div>
    </div>
  )
}

export default Signup
